var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"body"},[_c('div',{staticClass:"test"},[_c('input',{staticClass:"test-btn",attrs:{"type":"button","value":"开始测试","id":"test"},on:{"click":_vm.goFirst}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }